<div class="optimization-wrapper">
  <div class="header">
    <div class="header-content">
      <mat-icon class="info-icon">info</mat-icon>
      <span class="bold"> {{ title }} </span>
    </div>
    <mat-icon class="close-icon" (click)="closeRecommendationTile()">close</mat-icon>
  </div>
  <div class="description" *ngIf="!isTextExceedingWrapper">
    <span #actualText>
      {{ description }}
    </span>
  </div>
  <div
    class="description"
    *ngIf="isTextExceedingWrapper"
    matTooltipPosition="above"
    [matTooltip]="description"
  >
    <span #actualText>
      {{ description }}
    </span>
  </div>
</div>
